var Curriculog = Curriculog || {};

Curriculog.EntityFlyoutView = (function ($, _, Backbone, EntityFlyoutView) {

	var EntityFlyoutView = Curriculog.CurriculogView.extend({
		initialize: function (options) {
			this.roles = options.roles;
			this.entities = options.entities;
			this.roleTypes = options.roleTypes;
			this.entityCanDelete = options.entityCanDelete;
			this.entityRoleCanDeletes = options.entityRoleCanDeletes;
			this.entityParentsCanDelete = options.entityParentsCanDelete;
			this.committees = options.committees;
			this.entityTypes = options.entityTypes;
			this.relationships = options.relationships;
			this.currentEntityID = options.currentEntityID;
			this.entity = this.entities.get(this.currentEntityID);
      this.params = options.params;

			var sanitizedEntityModel = this.entity.getSanitizedModel();

			this.flyoutTitle = new Curriculog.FlyoutTitleView({
				model: this.entity,
				title: sanitizedEntityModel.get('name'),
        params: this.params
			});

			this.manageEntities = new Curriculog.ManageEntityView({
				roles: this.roles,
				entityCanDelete: this.entityCanDelete,
				entities: this.entities,
				entityTypes: this.entityTypes,
				relationships: this.relationships,
				currentEntityID: this.currentEntityID,
			});

			this.manageParents = new Curriculog.ManageParentsView({
				entities: this.entities,
				collection: this.relationships,
				currentEntityID: this.currentEntityID,
				entityParentsCanDelete: this.entityParentsCanDelete,
			});

			this.manageRoles = new Curriculog.ManageRolesView({
				roleTypes: this.roleTypes,
				committees: this.committees,
				roles: this.roles,
				entities: this.entities,
				currentEntityID: this.currentEntityID,
				entityRoleCanDeletes: this.entityRoleCanDeletes,
        params: this.params
			});

			this.render();
		},

		render: function () {
			this.$el.append(this.flyoutTitle.el);
			this.$el.append(this.manageEntities.el);
			this.$el.append(this.manageParents.el);
			this.$el.append(this.manageRoles.el);
		},

		cleanup: function () {
			this.flyoutTitle.remove();
			this.manageEntities.remove();
			this.manageParents.remove();
			this.manageRoles.remove();
			this.remove();
		}
	});

	return EntityFlyoutView;

})($, _, Backbone, Curriculog.EntityFlyoutView || {});
